module.exports = __webpack_public_path__ + "img/09499893000136.1aeec3f1.png";